import React, { createContext, useContext, useEffect, useState } from 'react';
import api from '../services/api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/users/me')
      .then((res) => setUser(res.data))
      .catch(() => setUser(null))
      .finally(() => setLoading(false));
  }, []);

  async function login(email, password) {
    await api.post('/auth/login', { email, password });
    const { data } = await api.get('/users/me');
    setUser(data);
    return data;
  }

  async function logout() {
    try { await api.post('/auth/logout'); } catch (_) {}
    setUser(null);
  }

  async function updatePreferences(partial) {
    const nextPreferences = { ...(user?.preferences || {}), ...partial };
    setUser((prev) => (prev ? { ...prev, preferences: nextPreferences } : prev));
    try {
      await api.put('/users/me', { preferences: nextPreferences });
    } catch (e) {
      console.error('Failed to save preferences', e);
    }
  }

  async function updateCompanySettings(partial) {
    const { data } = await api.put('/companies/me', { settings: partial });
    setUser((prev) =>
      prev ? {
        ...prev,
        company: {
          ...prev.company,
          settings: data?.settings ?? { ...(prev.company?.settings || {}), ...partial },
        },
      } : prev,
    );
  }

  return (
    <AuthContext.Provider
      value={{
        user,
        company: user?.company ?? null,
        loading,
        login,
        logout,
        updatePreferences,
        updateCompanySettings,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
